<template>
	<el-dialog :title="$t('supplier.dialog[0]')" :visible.sync="isShowSupplier" :before-close='closeSupplier'
		:modal="false" class="suppli-dialog" style="width: 60%;margin: 0 auto;font-size:20px;">
		<div>
			<div style="display: flex;">
				<el-input v-model="search" style="width:200px;"></el-input>
				<el-button @click='getSupplierList' type="primary">{{$t('GoodsList.search')}}</el-button>
			</div>
			<div>
				<el-radio-group v-model="selectObj"
					style="display: flex;flex-direction: column;text-align: left;height: 650px;overflow: hidden;overflow-y: scroll;">
					<el-radio v-for="(item,index) in supplierlist" :label="item" :key="item.index" style="margin:10px;">
						{{item.name}}</el-radio>
				</el-radio-group>
			</div>

			<el-footer>
				<el-pagination style="text-align: end;" v-if="supplierlist != ''" @size-change="getSupplierList"
					@current-change="getSupplierList" :current-page.sync="currentPage" :page-size="pagesize"
					layout="total, prev, pager, next" :total="tableTotal"></el-pagination>
			</el-footer>

			<div style="text-align: end;">
				<el-button @click='supplierConfirm' type="primary" style="text-align: end;">
					{{$t('header.confirmButtonText')}}</el-button>
			</div>
		</div>
	</el-dialog>

</template>

<script>
	import {
		mapState
	} from 'vuex';
	import wmsApi from '@/request/wmsApi'
	export default {
		name: 'SupplierSelector',
		props: {
			isShowSupplier: {
				required: true,
				default: false,
				type: Boolean
			}
		},
		data() {
			return {
				currentPage: 1,
				pagesize: 50,
				tableTotal: 0,
				supplierlist: [],
				search: '',
				selectObj: {},
			}
		},
		mounted() {
			this.getSupplierList();
		},
		methods: {
			async getSupplierList() {
				let listRes = await wmsApi.GetSupplierList(this.token, this.search, '', this.currentPage, this
					.pagesize, "1");
				this.supplierlist = listRes.data;
				this.tableTotal = listRes.totalCount;
			},
			supplierConfirm() {
				this.$emit('selectSupplier', this.selectObj)
				this.search = '',
					this.getSupplierList();
			},
			closeSupplier(done) {
				this.$confirm(this.$t('header.confirm'), this.$t('header.tishi'), {
						confirmButtonText: this.$t('header.confirmButtonText'),
						cancelButtonText: this.$t('header.cancelButtonText'),
						type: 'warning',
					}).then(() => {
						this.search = '',
							this.getSupplierList();
						this.$emit('selectSupplier', this.selectObj)
						done();
					})
					.catch(() => {});
			},
		},
		computed: mapState({
			token: state => state.user.token,
		})

	}
</script>

<style>
	.suppli-dialog .el-dialog .el-dialog__header {
		background: #2C3E50;
	}

	.suppli-dialog .el-dialog .el-dialog__header .el-dialog__title {
		color: white;
	}

	.suppli-dialog .el-dialog .el-dialog__header .el-dialog__headerbtn {
		color: white;
		font-weight: bold;
		font-size: 20px;
	}

	.suppli-dialog .el-dialog {
		margin-top: 5vh !important;
	}

	.suppli-dialog::-webkit-scrollbar {
		width: 0 !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/PurchasingManagement/SupplierSelector.vue